// Question Data

export const questionsBank = {
  "ISO-9001:2015 module-4": [
    {
      question: "What is the primary purpose of an ISO audit?",
      options: [
        "To find mistakes made by employees",
        "To verify conformity and effectiveness of the management system",
        "To punish departments for non-compliance",
        "To replace existing processes",
      ],
      // correctAnswer: "To verify conformity and effectiveness of the management system",
    },
    {
      question:
        "Which ISO auditing principle ensures auditors remain unbiased and free from conflicts of interest?",
      options: [
        "Integrity",
        "Confidentiality",
        "Independence",
        "Fair Presentation",
      ],
      // correctAnswer: "Independence",
    },
    {
      question: "Which clauses of ISO 9001:2015 are considered non-auditable?",
      options: [
        "Clauses 4 to 10",
        "Clauses 1 to 3",
        "Clauses 5 to 8",
        "Clauses 9 and 10",
      ],
      // correctAnswer: "Clauses 1 to 3",
    },
    {
      question: "What is the main objective of Annex SL?",
      options: [
        "To replace ISO standards",
        "To provide a common structure for management system standards",
        "To define audit criteria",
        "To provide product specifications",
      ],
      // correctAnswer: "To provide a common structure for management system standards",
    },
    {
      question:
        "Which ISO 9001 principle focuses on meeting customer requirements and increasing customer satisfaction?",
      options: [
        "Leadership",
        "Customer Focus",
        "Process Approach",
        "Relationship Management",
      ],
      // correctAnswer: "Customer Focus",
    },
    {
      question:
        "Which type of audit is conducted by an organization's own employees?",
      options: [
        "First-party audit",
        "Second-party audit",
        "Third-party audit",
        "Certification audit",
      ],
      // correctAnswer: "First-party audit",
    },
    {
      question:
        "A certification body conducting an ISO certification audit is known as:",
      options: [
        "Internal audit",
        "Supplier audit",
        "Third-party audit",
        "Process audit",
      ],
      // correctAnswer: "Third-party audit",
    },
    {
      question: "Audit criteria refer to:",
      options: [
        "The auditor's opinion",
        "The requirements against which audit evidence is compared",
        "The organization's financial records",
        "Employee performance reviews",
      ],
      // correctAnswer: "The requirements against which audit evidence is compared",
    },
    {
      question: "What should be established before conducting an audit?",
      options: [
        "Audit objectives, scope, and criteria",
        "Employee salary details",
        "Marketing strategy",
        "Sales targets",
      ],
      // correctAnswer: "Audit objectives, scope, and criteria",
    },
    {
      question:
        "Which of the following is an appropriate method of collecting audit evidence?",
      options: [
        "Guessing",
        "Personal opinion",
        "Interviewing employees and reviewing records",
        "Assuming compliance",
      ],
      // correctAnswer: "Interviewing employees and reviewing records",
    },
  ],
  "ISO-42001:2023 module-4": [
    {
      question:
        "What is the primary responsibility of an ISO/IEC 42001 lead auditor?",
      options: [
        "Develop AI software",
        "Lead and manage the audit process",
        "Approve AI models",
        "Manage company finances",
      ],
      // Answer: b
    },
    {
      question: "Which clause addresses internal audit?",
      options: ["Clause 5", "Clause 7", "Clause 9.2", "Clause 10"],
      // Answer: c
    },
    {
      question: "What should an auditor use to verify conformity?",
      options: [
        "Personal opinion",
        "Objective evidence",
        "Verbal assumptions only",
        "Customer complaints only",
      ],
      // Answer: b
    },
    {
      question: "Which is an essential audit principle?",
      options: ["Impartiality", "Sales growth", "Profitability", "Marketing"],
      // Answer: a
    },
    {
      question: "What should an auditor do when a nonconformity is identified?",
      options: [
        "Ignore it",
        "Record and communicate the finding based on objective evidence",
        "Correct it personally",
        "Delete the evidence",
      ],
      // Answer: b
    },
    {
      question: "What is audit evidence?",
      options: [
        "Verifiable records, statements, or information relevant to audit criteria",
        "Auditor's personal opinion",
        "Informal assumptions",
        "Marketing information only",
      ],
      // Answer: a
    },
    {
      question: "What is the purpose of an audit opening meeting?",
      options: [
        "To discuss sales targets",
        "To establish the audit framework and communicate the audit process",
        "To approve AI models",
        "To train employees",
      ],
      // Answer: b
    },
    {
      question:
        "What should an auditor maintain regarding confidential information?",
      options: [
        "Public disclosure",
        "Confidentiality",
        "Social media publication",
        "Unrestricted distribution",
      ],
      // Answer: b
    },
    {
      question: "What is the purpose of an audit report?",
      options: [
        "To document audit results and conclusions",
        "To replace the AIMS",
        "To develop AI software",
        "To establish sales targets",
      ],
      // Answer: a
    },
    {
      question: "What should the lead auditor ensure during an audit?",
      options: [
        "Audit objectives and criteria are clearly established and followed",
        "All findings are eliminated before reporting",
        "Management performs the audit",
        "Evidence is not recorded",
      ],
      // Answer: a
    },
  ],
};
